import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, reactive, ref, provide, nextTick } from 'vue';
import CButton from '@/components/shared/CButton';
import type { CanvasEx } from '@/typings/canvas';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import type { ImageEffectType } from '@/typings/customilyElements/imageEffectType';
import ImageEffectsPropertiesList from '@/components/DesignStudio/ImageEffectsProperties/components/list/ImageEffectsPropertiesList.vue';
import ImageEffectsPropertiesCreate from '@/components/DesignStudio/ImageEffectsProperties/components/create/ImageEffectsPropertiesCreate.vue';
import store from '@/store';

interface Props {
    canvas: CanvasEx;
    imageElement: ImagePlaceholderElement;
    editMode?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsProperties',
  props: {
    canvas: null,
    imageElement: null,
    editMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    canvas: CanvasEx;
    imageElement: ImagePlaceholderElement;
    editMode?: boolean;
};



const model = reactive({
    imageEffects: props.imageElement?.imageEffects || []
});

// Provide: id del efecto a abrir (último agregado)
const openEffectId = ref<string | null>(null);
provide('openEffectId', openEffectId);

const isDisabled = computed(() => props.imageElement?.locked);
const hasEffects = computed(() => model.imageEffects && model.imageEffects.length > 0);
const imageEffect = computed(() => store.state.imageEffectsProperties?.imageEffect);

const updateImageEffects = () => {
    if (!props.imageElement || isDisabled.value) return;

    props.imageElement.set('imageEffects', model.imageEffects);

    if (props.editMode) {
        props.imageElement.setEditedProp('imageEffects');
    }

    props.canvas.requestRenderAll();
};
const openAddEffectModal = () => {
    store?.dispatch('imageEffectsProperties/openAddModal');
};

const removeImageEffect = (effect: ImageEffectType) => {
    if (!model.imageEffects || isDisabled.value) return;

    const effectId = effect.id;
    const index = model.imageEffects.findIndex((e) => e.id === effectId);

    if (index !== -1) {
        model.imageEffects.splice(index, 1);
        updateImageEffects();
    }
};

const updateImageEffect = (effect: ImageEffectType) => {
    if (!model.imageEffects || isDisabled.value) return;

    const effectId = effect.id;
    const index = model.imageEffects.findIndex((e) => e.id === effectId);

    if (index !== -1) {
        model.imageEffects[index] = effect;
        model.imageEffects = [...model.imageEffects];
        updateImageEffects();
    }
};

const handleReorder = (newEffects: ImageEffectType[]) => {
    if (!model.imageEffects || isDisabled.value) return;

    model.imageEffects = newEffects;
    updateImageEffects();
};

const handleImmediateEdit = async (imageEffect: ImageEffectType) => {
    const { presetId, id } = imageEffect;
    const validPresets = [
        'gemini-custom-prompt',
        'gemini-openrouter-custom-prompt',
        'openai-openrouter-custom-prompt',
        'openai-custom-prompt',
        'cutout-pro-cartoon-selfie'
    ];
    if (presetId && validPresets.includes(presetId)) {
        await nextTick();
        openEffectId.value = id ?? null;
    }
};

watch(
    () => props.imageElement?.imageEffects,
    () => {
        if (props.imageElement?.imageEffects) {
            model.imageEffects = [...props.imageElement.imageEffects];
        } else {
            model.imageEffects = [];
        }
    },
    { deep: true }
);

watch(
    () => imageEffect.value,
    async (value) => {
        if (value) {
            model.imageEffects.push(value);
            updateImageEffects();
            store.dispatch('imageEffectsProperties/closeAddModal');
            await handleImmediateEdit(value);
        }
    }
);

return { __sfc: true,props, model, openEffectId, isDisabled, hasEffects, imageEffect, updateImageEffects, openAddEffectModal, removeImageEffect, updateImageEffect, handleReorder, handleImmediateEdit, CButton, ImageEffectsPropertiesList, ImageEffectsPropertiesCreate }
}

})